import { createFileRoute } from '@tanstack/react-router'

import { ContactsSearchSchema } from '@/pages/brevo/contacts/contacts-search'

export const Route = createFileRoute('/_layout/brevo/contacts')({
  validateSearch: ContactsSearchSchema,
})
